import { useQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { ArrowRightIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { NVC_CASE_TYPE_MAP } from '@/lib/constants/nvc/case-type'
import { getUserQuery } from '@/lib/queries/business/v2/user/queries'
import { cn } from '@/lib/utils'

import { ClientPortalArea } from '../../ui/client-portal-area/client-portal-area'
import { CheckDolCase } from './check-dol-case/check-dol-case'
import { CheckNvcCase } from './check-nvc-case/check-nvc-case'
import { CheckUscisCase } from './check-uscis-case/check-uscis-case'
import { useFindTargetCase } from './hooks/use-find-target-case'
import { NotifyApplicantSwitch } from './notify-applicant-switch'

export const CaseDetail = () => {
  const { targetCase } = useFindTargetCase()

  const { data: dataUser } = useQuery(getUserQuery)

  const applicantId = targetCase?.applicant_path_id
  const caseType = targetCase?.case_type
  const caseId = targetCase?.case_id

  const isDolCase = Boolean(targetCase?.is_dol)
  const isNvcCase = caseType === NVC_CASE_TYPE_MAP.immigrant || caseType === NVC_CASE_TYPE_MAP['non-immigrant']

  return (
    <div>
      <div className={cn('mb-6', 'h-2', 'w-full', 'bg-secondary')} />

      {!isNvcCase && (
        <>
          {!isDolCase && <CheckUscisCase />}
          {isDolCase && <CheckDolCase />}
        </>
      )}
      {isNvcCase && <CheckNvcCase />}

      <div className={cn('mt-6')}>
        <ClientPortalArea
          linkButton={
            <Link
              to={
                dataUser?.hasSubscription
                  ? '/client-portal/internal/$applicantId/$caseId'
                  : '/client-portal/internal/sample'
              }
              target="_blank"
              rel="noreferrer"
              className={cn('w-full')}
              params={{
                applicantId: applicantId ? `${applicantId}` : '',
                caseId: caseId ? `${caseId}` : '',
              }}
            >
              <Button className={cn('flex-1', 'w-full')} asChild>
                <div className={cn('flex gap-x-2')}>
                  Client Portal
                  <ArrowRightIcon size={16} />
                </div>
              </Button>
            </Link>
          }
        />
      </div>

      <NotifyApplicantSwitch />
    </div>
  )
}
